import { request } from "../apiService";
import { postUser, PutUserInput } from "../../types/api/user";

export const acceptCgu = async (): Promise<void> => {
    return await request("/v3/user/cgu", {
        method: "PUT",
    });
};

export const updateUser = async (input: PutUserInput) => {
    return await request("/v2/users", {
        method: "PUT",
        input,
    });
};

export const createUser = async (userInput: postUser) => {
    let input: any = {
        token: userInput.token,
        firstname: userInput.firstname,
        lastname: userInput.lastname,
        password: userInput.password,
        confirmPassword: userInput.confirmPassword,
    };

    if (userInput.email) {
        input = { ...input, email: userInput.email };
    }

    return await request("/v2/users", {
        method: "POST",
        input,
        skipAuth: true,
    });
};

export const updateUserPassword = async (
    oldPassword: string,
    newPassword: string,
    confirmPassword: string
) => {
    return await request("/v2/users/password", {
        method: "PUT",
        input: { oldPassword, newPassword, confirmPassword },
    });
};